<template>

<CrearUsuario></CrearUsuario>

</template>


<script>

import CrearUsuario from '../../components/PermisosEnCurso.vue';

export default {


 components:{

     CrearUsuario

  }

}


</script>